import React from 'react';
import './stylesManualBling.css';
import blingConfiguracoes from '../../imagens/integracoes/bling_configuracoes.png';
import blingCadastro from '../../imagens/integracoes/bling_cadastro.png';
import blingCadastroApp from '../../imagens/integracoes/bling_cadastroapp.png';
import blingCadastroAppSelecao from '../../imagens/integracoes/bling_cadastroappselecao.png';
import blingCadastroAppEscopo from '../../imagens/integracoes/bling_cadastroappescopo.png';
import mascConfiguracoes from '../../imagens/integracoes/masc_configuracoes.png';
import mascConfiguracoesEcommerce from '../../imagens/integracoes/masc_configuracoesecommerce.png';
import blingDados from '../../imagens/integracoes/bling_dados.png';

const ManualBling = () => {
    return (
        <div className="mb-content">

            <h2 className="mb-intro">Passo a passo para configurar o aplicativo MASC no BLING</h2>

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">1</span>
                    <h3 className="mb-step__title">Acesse o Bling e faça o login na sua conta.</h3>
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">2</span>
                    <h3 className="mb-step__title">
                        No canto superior direito passe o mouse sobre a engrenagem e clique na opção "Todas as configurações".
                    </h3>
                </div>
                <div className="mb-step__body">
                    <img src={blingConfiguracoes} className="mb-step__image" alt="Bling Configurações" />
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">3</span>
                    <h3 className="mb-step__title">
                        No menu lateral clique na opção "Cadastros" e depois clique na opção "Cadastro de aplicativos".
                    </h3>
                </div>
                <div className="mb-step__body">
                    <img src={blingCadastro} className="mb-step__image" alt="Bling Cadastro" />
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">4</span>
                    <h3 className="mb-step__title">
                        Na tela de Cadastro de aplicativo, clique em "CRIAR NOVO APLICATIVO".
                    </h3>
                </div>
                <div className="mb-step__body">
                    <img src={blingCadastroApp} className="mb-step__image" alt="Bling Cadastro App" />
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">5</span>
                    <h3 className="mb-step__title">
                        Em "Tipo do aplicativo", selecione a opção "Tenha acesso à API v3 do Bling!". Depois em "Selecione o uso do aplicativo",
                        selecione a opção "Privado" e em seguida clique em "Próximo".
                    </h3>
                </div>
                <div className="mb-step__body">
                    <img src={blingCadastroAppSelecao} className="mb-step__image" alt="Bling Cadastro App Seleção" />
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">6</span>
                    <h3 className="mb-step__title">
                        Na tela "Insira os dados do seu aplicativo" preencha os dados obrigatórios conforme documento encaminhado no ato da contratação.
                    </h3>
                </div>
                <div className="mb-step__body">
                    <ul className="mb-list">
                        <li>Nome</li>
                        <li>Categoria</li>
                        <li>Link de redirecionamento</li>
                        <li>Link da homepage</li>
                        <li>Nome do desenvolvedor</li>
                        <li>E-mail</li>
                        <li>Celular</li>
                    </ul>
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">7</span>
                    <h3 className="mb-step__title">
                        Na sequência em "Selecione os escopos", adicione as opções conforme documento encaminhado no ato da contratação, e clique em "Salvar".
                    </h3>
                </div>
                <div className="mb-step__body">
                    <img src={blingCadastroAppEscopo} className="mb-step__image" alt="Bling Cadastro App Escopo" />
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">8</span>
                    <h3 className="mb-step__title">
                        O próximo passo é acessar o sistema MASC com seu Login e Senha, navegar no menu lateral em:
                        Configuração &gt; Integrações &gt; E-Commerce.
                    </h3>
                </div>
                <div className="mb-step__body">
                    <img src={mascConfiguracoes} className="mb-step__image" alt="MASC Configurações" />
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">9</span>
                    <h3 className="mb-step__title">
                        Na tela de "Integração E-Commerce" informe os campos "Client ID" e "Client Secret". Essas informações estão
                        na tela de cadastro de aplicativo do Bling. Após incluir as informações clique no botão "Autenticar".
                    </h3>
                </div>
                <div className="mb-step__body">
                    <img src={blingDados} className="mb-step__image" alt="Bling Dados" />
                    <img src={mascConfiguracoesEcommerce} className="mb-step__image" alt="MASC Configurações E-Commerce" />
                </div>
            </section>

            <div className="mb-divider" />

            <section className="mb-step">
                <div className="mb-step__header">
                    <span className="mb-step__number">10</span>
                    <h3 className="mb-step__title">
                        Após essa etapa, você será redirecionado para o site do Bling. Faça login com seu usuário e senha para concluir a integração. Em seguida, a configuração estará finalizada e você já poderá iniciar a sincronização dos produtos com o Bling.
                    </h3>
                </div>
            </section>

        </div>
    );
};

export default ManualBling;
